import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FINANCE_SUB_MODULES, hasFinanceSubModuleAccess } from 'src/app/constants/finance.constant';

export const financeGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const modulesStr = localStorage.getItem('modules') || '';
  const userModules = modulesStr
    .split(',')
    .map((m) => m.trim().toUpperCase())
    .filter(Boolean);

  const hasFinanceAccess = userModules.includes('FINANCE');
  if (!hasFinanceAccess) {
    router.navigate(['/home']);
    return false;
  }

  const dept = (localStorage.getItem('department') || '').trim().toUpperCase();
  const hasProjects = hasFinanceSubModuleAccess(FINANCE_SUB_MODULES.PROJECTS);
  const hasVendors = hasFinanceSubModuleAccess(FINANCE_SUB_MODULES.VENDORS) || dept === 'OPERATIONS';

  if (!hasProjects && !hasVendors) {
    router.navigate(['/home']);
    return false;
  }

  const url = (state?.url || '').split('?')[0].split('#')[0];
  const segments = url.split('/').filter(Boolean);
  const target = segments[segments.length - 1];

  // Root /finance navigation
  if (!target || target === 'finance') {
    if (!hasProjects && hasVendors) {
      router.navigate(['/finance/vendors']);
      return false;
    }
    return true;
  }

  // Vendors page
  if (target === 'vendors') {
    if (!hasVendors) {
      router.navigate(['/finance/dashboard']);
      return false;
    }
    return true;
  }

  // Projects, Invoices, Dashboard, Targets, Plan, Opening data
  if (['dashboard', 'projects', 'invoices', 'targets', 'plan', 'import'].includes(target)) {
    if (!hasProjects) {
      if (hasVendors) {
        router.navigate(['/finance/vendors']);
      } else {
        router.navigate(['/home']);
      }
      return false;
    }
    return true;
  }

  // Budgets: only for the people ticked for it (an opt-in section), Admins included
  if (target === 'budgets' && !hasFinanceSubModuleAccess(FINANCE_SUB_MODULES.BUDGETS)) {
    router.navigate([hasProjects ? '/finance/dashboard' : '/finance/vendors']);
    return false;
  }

  return true;
};

